import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiServicesService } from './api-services.service';

@Injectable({
  providedIn: 'root',
})

export class SocketService {
  private socket!: Socket;
  isConnected:boolean = false;

  totalcouunt = new BehaviorSubject<any>('');
  total_count = this.totalcouunt.asObservable();

  constructor(private api:ApiServicesService){}

  connect(authToken: string): void {
    this.socket = io(this.api.apiUrl, {
      query: { authToken },
      transports: ['websocket', 'polling'],
    });

    this.socket.on('connect', () => {
      this.emit('user_connected', authToken);
      this.isConnected = true;
    });

    this.socket.on('disconnect', () => {
      this.isConnected = false;
    });
  }

  on(event: string): Observable<any> {
    return new Observable((observer) => {
      this.socket.on(event, (data: any) => observer.next(data));
    });
  }

  emit(event: string, data: any): void {
    this.socket.emit(event, data);
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
}
